export const findMetaData = (metaDataVal, metadataList) => {
    const metaData = metadataList.find((meta) => meta.id === parseInt(metaDataVal));
    return metaData;
  }

/**
 * The input data format is Wed Jul 19 2023 10:14:30 GMT+1000 (Australian Eastern Standard Time)
 * and will return the date in 2023-10-10 format
 * @param {Date} inputData 
 * @returns {string|null}
 */
export const formatDate = (inputData) => {
  if (!inputData) {
    return null;
  }
  
  const year = inputData.getFullYear();
  const month = String(inputData.getMonth() + 1).padStart(2, "0");
  const day = String(inputData.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  
  return formattedDate;
}
